// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Assets/fonts/FFClanProCondRgNews.TTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Assets/fonts/FFClanProRegular.TTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Assets/fonts/FFClanProMedium.TTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./Assets/fonts/allFonts/FFClanProBlk.TTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./Assets/fonts/allFonts/FFClanProThin.TTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./Assets/fonts/allFonts/FFClanProUltra.TTF", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: 'Clans Pro';
	font-weight: 300;
	src: local('Clans Pro'),
		url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
	font-family: 'Clans Pro';
	font-weight: 400;
	src: local('Clans Pro'),
		url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
	font-family: 'Clans Pro';
	font-weight: 500;
	src: local('Clans Pro'),
		url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
	font-family: 'Clans Pro';
	font-weight: 700;
	src: local('Clans Pro'),
		url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
	font-family: 'Clans Pro';
	font-weight: 800;
	src: local('Clans Pro'),
		url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
	font-family: 'Clans Pro';
	font-weight: 900;
	src: local('Clans Pro'),
		url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}
/* @font-face {
	font-family: 'Clans Pro';
	font-weight: 900;
	src: local('Clans Pro'),
		url(./Assets/fonts/allFonts/FFClanProBlk.TTF) format('truetype');
}
@font-face {
	font-family: 'Clans Pro';
	font-weight: 900;
	src: local('Clans Pro'),
		url(./Assets/fonts/allFonts/FFClanProBlk.TTF) format('truetype');
}
@font-face {
	font-family: 'Clans Pro';
	font-weight: 900;
	src: local('Clans Pro'),
		url(./Assets/fonts/allFonts/FFClanProBlk.TTF) format('truetype');
} */

/* @font-face {
	font-family: 'Clans Pro';
	font-weight: 950;
	src: local('Clans Pro'),
		url(./Assets/fonts/allFonts/FFClanProUltra.TTF) format('truetype');
}
@font-face {
	font-family: 'Clans Pro';
	font-weight: 950;
	src: local('Clans Pro'),
		url(./Assets/fonts/allFonts/FFClanProMedium.TTF) format('truetype');
} */
/* @font-face {
	font-family: 'Clans Pro';
	font-weight: 950;
	src: local('Clans Pro'),
		url(./Assets/fonts/allFonts/FFClanProRegular.TTF) format('truetype');
}
@font-face {
	font-family: 'Clans Pro';
	font-weight: 950;
	src: local('Clans Pro'),
		url(./Assets/fonts/allFonts/FFClanProRgNarNews.TTF) format('truetype');
} */
@font-face {
	font-family: 'Clans Pro';
	font-weight: 950;
	src: local('Clans Pro'),
		url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}
@font-face {
	font-family: 'Clans Pro';
	font-weight: 950;
	src: local('Clans Pro'),
		url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CACC,wBAAwB;CACxB,gBAAgB;CAChB;4DAC+D;AAChE;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB;4DAC4D;AAC7D;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB;4DAC2D;AAC5D;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB;4DAC2D;AAC5D;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB;4DAC2D;AAC5D;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB;4DACiE;AAClE;AACA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;;;;;;;;;;;GAWG;AACH;;;;;;;;;;;GAWG;AACH;CACC,wBAAwB;CACxB,gBAAgB;CAChB;4DACkE;AACnE;AACA;CACC,wBAAwB;CACxB,gBAAgB;CAChB;4DACmE;AACpE","sourcesContent":["@font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 300;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/FFClanProCondRgNews.TTF) format('truetype');\n}\n\n@font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 400;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/FFClanProRegular.TTF) format('truetype');\n}\n\n@font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 500;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/FFClanProMedium.TTF) format('truetype');\n}\n\n@font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 700;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/FFClanProMedium.TTF) format('truetype');\n}\n\n@font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 800;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/FFClanProMedium.TTF) format('truetype');\n}\n\n@font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 900;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/allFonts/FFClanProBlk.TTF) format('truetype');\n}\n/* @font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 900;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/allFonts/FFClanProBlk.TTF) format('truetype');\n}\n@font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 900;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/allFonts/FFClanProBlk.TTF) format('truetype');\n}\n@font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 900;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/allFonts/FFClanProBlk.TTF) format('truetype');\n} */\n\n/* @font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 950;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/allFonts/FFClanProUltra.TTF) format('truetype');\n}\n@font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 950;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/allFonts/FFClanProMedium.TTF) format('truetype');\n} */\n/* @font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 950;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/allFonts/FFClanProRegular.TTF) format('truetype');\n}\n@font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 950;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/allFonts/FFClanProRgNarNews.TTF) format('truetype');\n} */\n@font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 950;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/allFonts/FFClanProThin.TTF) format('truetype');\n}\n@font-face {\n\tfont-family: 'Clans Pro';\n\tfont-weight: 950;\n\tsrc: local('Clans Pro'),\n\t\turl(./Assets/fonts/allFonts/FFClanProUltra.TTF) format('truetype');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
